import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { db } from '../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import '../styles.css';

const NavBar = () => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path ? { backgroundColor: '#e5e7eb', color: '#111827', borderRadius: 8 } : {};
    const { user, isAdmin, logout } = useAuth();
    const [dynamicSections, setDynamicSections] = useState([]);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, 'gallerySections'), (snap) => {
            const slugs = snap.docs.map(d => (d.data().slug || d.data().name || '')).filter(Boolean);
            setDynamicSections(slugs);
        }, () => setDynamicSections([]));
        return () => unsub();
    }, []);

    return (
        <nav className="navbar">
            <div className="logo-container">
                <div className="profile-image">
                    <img src="/protrait3.jpg" alt="Tzofit Ofengenden portrait" />
                </div>
                <div className="logo">Tzofit Ofengenden</div>
            </div>
            <ul className="nav-links">
                <li><Link to="/" style={isActive('/')}>Home</Link></li>
                <li className="dropdown">
                    <Link to="/gallery" className="dropbtn" style={isActive('/gallery')}>Gallery</Link>
                    <ul className="dropdown-content">
                        {dynamicSections
                            .filter(s => !['landscape','abstract','realms','patterns'].includes(s.toLowerCase()))
                            .map((slug) => (
                                <li key={slug}><Link to={`/gallery/${slug}`} style={isActive(`/gallery/${slug}`)}>{slug.charAt(0).toUpperCase() + slug.slice(1)}</Link></li>
                            ))}
                        <li><Link to="/gallery/landscape" style={isActive('/gallery/landscape')}>Landscape</Link></li>
                        <li><Link to="/gallery/abstract" style={isActive('/gallery/abstract')}>Abstract</Link></li>
                        <li><Link to="/gallery/realms" style={isActive('/gallery/realms')}>Realms</Link></li>
                        <li><Link to="/gallery/patterns" style={isActive('/gallery/patterns')}>Patterns</Link></li>
                    </ul>
                </li>
                <li><Link to="/about" style={isActive('/about')}>About</Link></li>
                <li><Link to="/exhibition" style={isActive('/exhibition')}>Exhibitions</Link></li>
                <li><Link to="/store" style={isActive('/store')}>Store</Link></li>
                {isAdmin && (
                    <li><Link to="/admin" style={isActive('/admin')}>Admin</Link></li>
                )}
                {!user && (
                    <>
                        <li><Link to="/login" style={isActive('/login')}>Login</Link></li>
                    </>
                )}
                {user && (
                    <li>
                        <button className="dropbtn" onClick={logout}>Logout</button>
                    </li>
                )}
                <li><Link to="/contact" style={isActive('/contact')}>Contact</Link></li>
                
            </ul>
        </nav>
    );
};

export default NavBar;